import { createFileRoute } from "@tanstack/react-router";
import AppLayout from "@/components/layout/AppLayout";
import VoiceAgentHost from "@/components/voice/VoiceAgentHost";

/**
 * Pathless layout route for the authenticated coach area.
 * AppLayout enforces authentication, role and feature-flag redirects — the
 * exact gating the pre-migration `<Route element={<AppLayout />}>` provided.
 * VoiceAgentHost keeps the "Hey Thiia" voice agent alive across pages.
 */
export const Route = createFileRoute("/_app")({
  component: AppShell,
});

function AppShell() {
  return (
    <>
      <AppLayout />
      <VoiceAgentHost />
    </>
  );
}
